import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { event } from 'jquery';
import Swal from 'sweetalert2'
import { ProductCategoryService } from '../product-category-service';


@Component({
  selector: 'app-product-category-add',
  templateUrl: './product-category-add.component.html',
  styleUrls: ['./product-category-add.component.scss']
})
export class ProductCategoryAddComponent implements OnInit {

  submitted: boolean = false;
  addCategoryForm !:FormGroup
  selectedFile: SafeUrl = 'assets/images/product.png';
  constructor(private router : Router,private formBuilder : FormBuilder,private categoryService :ProductCategoryService) { }

  ngOnInit(): void {
    this.addCategoryForm = this.formBuilder.group({

      categoryImage : ['',Validators.required],
      categoryName : ['',Validators.required],
      categoryDesc : ['',Validators.required],
      // status : [null,Validators.required]

    })
  }

  removeFile() {
    this.selectedFile = 'assets/images/product.png';
    this.addCategoryForm.get('categoryImage')?.reset();
  }

  cancelButton(){
    this.router.navigateByUrl('/productCategory/productCategoryList')
  }

  saveProductCategory(){
    Swal.fire('Saved!', '', 'success')
  }
  
  setCategoryProfile(profile : any){
    console.log("Choose File Clicked");
    var file = profile.target.files[0];
    console.log(file.size);
    if(file.size > 50000){
      console.log("Greater than 50 KB");
      Swal.fire('Icon size cannot be greater than 50 KB','','error');
      return;
    }
    profile.target.value = '';
    console.log("add")
    this.addCategoryForm.get('categoryImage')?.setValue(file);
    var reader = new FileReader();
    reader.onloadend = this.handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);

  }

  handleReaderLoaded(e: any) {
    let reader = e.target;
    this.selectedFile = reader.result;
    console.log("Image Data"+reader.result)
  }

  // Method to validate category name input (alphanumeric, underscore, and spaces allowed)
  onCategoryNameKeyPress(event: any): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    
    // Allow: backspace, delete, tab, escape, enter
    if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
      return true;
    }
    
    // Allow: alphanumeric characters (a-z, A-Z, 0-9), underscore (_), and space
    const pattern = /^[a-zA-Z0-9_ ]$/;
    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    
    return true;
  }

  // Method to validate category description input (alphanumeric, underscore, and spaces allowed)
  onCategoryDescKeyPress(event: any): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    
    // Allow: backspace, delete, tab, escape, enter
    if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
      return true;
    }
    
    // Allow: alphanumeric characters (a-z, A-Z, 0-9), underscore (_), and space
    const pattern = /^[a-zA-Z0-9_ ]$/;
    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    
    return true;
  }

  addCategory(data:any){
  this.submitted = true;
  if(this.addCategoryForm.valid){
    console.log("Valid");
   console.log("Category Image : "+this.addCategoryForm.value.categoryImage);
    console.log("Category Name : "+data.categoryName);
    console.log("Category Description : "+data.categoryDesc);
    console.log("Category Status : "+data.status);

    let requestForm = {
      "name": data.categoryName,
      "description": data.categoryDesc,
      // "status": data.status
    };
    var requestData = new FormData();
    requestData.append("icon",this.addCategoryForm.value.categoryImage);
    requestData.append("request",JSON.stringify(requestForm));
    console.log(requestData);
    this.categoryService.saveCategory(requestData).subscribe((response:any)=>{
      console.log("Response : "+JSON.stringify(response));
      if (response.response.status == 200) {
        Swal.fire(response.response.message, '', 'success').then((result)=>{
          if (result.isConfirmed) {
            this.router.navigate(['/productCategory/productCategoryList']);
          } 
        });
        
      } else {
        Swal.fire(response.response.message, '', 'error');
        return;
      }
    });
    
  }else{
    console.log("Not Valid");
  }
  }

}
